import React from "react"
import { ILink } from "../../../../../gatsby-graphql"
import { DropdownMarker, Link } from "../../../../ui"
import {
  MenuItemWrapper,
  MenuLink,
  SubmenuItem,
  SubmenuWrapper,
} from "./menu-item-elements"

interface MenuItemProps {
  menuItem?: ILink
  submenuItems?: ILink[]
  locale?: string
}

export default function MenuItem({ menuItem, submenuItems, locale }: MenuItemProps) {
  if (!menuItem) {
    return <></>
  }

  return (
    <MenuItemWrapper>
      <MenuLink link={menuItem} locale={locale}>
        {menuItem.label}
        {submenuItems && submenuItems.length > 0 && <DropdownMarker />}
      </MenuLink>
      {submenuItems && submenuItems.length > 0 && (
        <SubmenuWrapper>
          {submenuItems.map(submenuItem => (
            <SubmenuItem key={submenuItem.slug}>
              <Link link={submenuItem} locale={locale} />
            </SubmenuItem>
          ))}
        </SubmenuWrapper>
      )}
    </MenuItemWrapper>
  )
}
